import { c as _c } from "react/compiler-runtime";
import { AnnotationIcon, EditIcon, UserIcon } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { MarkupsSummaryEmpty } from "@pages/project-details/project-overview/markups-summary/markups-summary-empty";
import { MarkupsSummaryStat } from "@pages/project-details/project-overview/markups-summary/markups-summary-stat";
import { useMarkupsSummaryLink } from "@pages/project-details/project-overview/markups-summary/use-markups-summary-link";
import { currentUserCreatedMarkupsSelector, currentUserMarkupsSelector, markupsSelector } from "@store/markups/markups-selector";
import { useAppSelector } from "@store/store-helper";

/** Amount of annotations in the project and, if any, of the ones assigned to and created by the current user */
export function MarkupsSummaryCounts() {
  const $ = _c(19);
  const allMarkups = useAppSelector(markupsSelector);
  const currentUserMarkups = useAppSelector(currentUserMarkupsSelector);
  const createdMarkups = useAppSelector(currentUserCreatedMarkupsSelector);
  const getMineLink = useMarkupsSummaryLink("mine");
  const getCreatedLink = useMarkupsSummaryLink("created");
  const getAllLink = useMarkupsSummaryLink("all");
  if (!allMarkups.length) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <MarkupsSummaryEmpty message="There are no annotations in this project." />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      xs: "column",
      sm: "row"
    };
    t1 = {
      gap: 2
    };
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== currentUserMarkups.length || $[4] !== getMineLink) {
    t2 = currentUserMarkups.length > 0 && <MarkupsSummaryStat icon={<UserIcon />} count={currentUserMarkups.length} label="Assigned to me" link={getMineLink({
      statuses: []
    }, "counts")} />;
    $[3] = currentUserMarkups.length;
    $[4] = getMineLink;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== createdMarkups.length || $[7] !== getCreatedLink) {
    t3 = createdMarkups.length > 0 && <MarkupsSummaryStat icon={<EditIcon />} count={createdMarkups.length} label="Created by me" link={getCreatedLink({
      statuses: []
    }, "counts")} />;
    $[6] = createdMarkups.length;
    $[7] = getCreatedLink;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <AnnotationIcon sx={{
      "& mask": {
        color: "common.white"
      }
    }} />;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = allMarkups.length;
  let t6;
  if ($[10] !== getAllLink) {
    t6 = getAllLink({
      statuses: []
    }, "counts");
    $[10] = getAllLink;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== allMarkups.length || $[13] !== t6) {
    t7 = <MarkupsSummaryStat icon={t4} count={t5} label="In this project" link={t6} />;
    $[12] = allMarkups.length;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t2 || $[16] !== t3 || $[17] !== t7) {
    t8 = <Stack direction={t0} sx={t1}>{t2}{t3}{t7}</Stack>;
    $[15] = t2;
    $[16] = t3;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}